import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import PortfolioDetailV2 from "./routes/PortfolioDetailsV2";
export default store => ({
  path: "studentPortfolio",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "course-studentPortfolio" */ "./components"
        ),
        import(
          /* webpackChunkName: "course-studentPortfolio" */ "./modules/StudentPortfolioModule"
        ),
        import(
          /* webpackChunkName: "course-studentPortfolio" */ "BulkActionsModal/modules/BulkActionsModalModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "studentPortfolio",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [PortfolioDetailV2(store)],
});
